export { default } from './theme-page-header';
